import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);
const user = {};
const isLogin = 'isLogin';
const draw = '';
const city = '';
//初审
const CensorCircs1=['补齐再审','先行审查','材料报审','正在审查','等待回复','正在复审','复审未过','初审通过','批准办理','任务办结','任务挂起'];
//复审
const CensorCircs2=['补齐再审','先行审查','材料报审','正在审查','等待回复','正在复审','复审未过','复审通过','批准办理','任务办结','任务挂起'];
//报审状态
const ApplyState=['提前受理','材料齐全'];
//收费状态
const store = new Vuex.Store({
  state () {
    return {
      user: null,
      isLogin: '0',
      draw:'',
      city:'',
      CensorCircs1,
      CensorCircs2,
      ApplyState,
      messageNumber:''
    }
  },
  getters: {
    getStorage: function (state) {
      if (!state.user) {
        state.user = JSON.parse(localStorage.getItem(user));
        state.isLogin = localStorage.getItem(isLogin);
        state.draw = localStorage.getItem(draw);
      }
      return state;
    },
  },
  mutations: {
    $_setLogin (state, value) {
      state.isLogin = value;
      localStorage.setItem(isLogin, value)
    },
    $_setDraw (state, value) {
      state.draw = value;
      localStorage.setItem(draw, value)
    },
    $_setCity (state, value) {
      state.city = value;
      localStorage.setItem('city', value)
    },
    $_setStorage (state, value) {
      state.user = value;
      localStorage.setItem(user, JSON.stringify(value))
    },
    $_removeStorage (state) {
      state.user = null;
      localStorage.removeItem(user);
      localStorage.removeItem(isLogin);
      localStorage.removeItem(draw);
    }
  }
});

export default store



// WEBPACK FOOTER //
// ./src/store/store.js